/* START sticky add to cart JS */
(function () {
  const bar = document.getElementById("StickyATCBar");
  const mainATC = document.querySelector(
    "#MainATC, [data-add-to-cart], .product-form__cart-submit"
  );
  if (!bar || !mainATC) return;
  let productData = {
    title:
      document.querySelector(".product-single__title")?.innerText || "",
    variant: "",
    price:
      document.querySelector("[data-product-price]")?.innerText || ""
  };
  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();

    return rect.top < window.innerHeight && rect.bottom > 0;
  }
  function showBar() {
    bar.classList.add("is-visible");
    document.body.classList.add("sticky-atc-active");
    bar.classList.remove("is-hidden");
  }
  function hideBar() {
    bar.classList.remove("is-visible");
    document.body.classList.remove("sticky-atc-active");
    bar.classList.add("is-hidden");
  }
  function toggleBar() {
    if (isElementInViewport(mainATC)) {
      hideBar();
    } else {
      showBar();
    }
  }
  function formatMoney(cents) {
    if (
      window.Shopify &&
      typeof Shopify.formatMoney === "function"
    ) {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }
  function getMainPriceHTML() {
    const priceSelectors = [
      "[data-product-price] .money",
      "[data-product-price]",
      ".product__price .money",
      ".price .money",
      ".product-single__price .money",
      ".money"
    ];
    for (let selector of priceSelectors) {
      const el = document.querySelector(selector);
      if (el && el.innerHTML.trim() !== "") {
        return el.innerHTML
          .replace(/USD|INR|CAD|EUR|GBP/gi, "")
          .trim();
      }
    }
    return "";
  }
  function getSelectedVariantFromDOM() {
    const selected = [];
    document
      .querySelectorAll("fieldset.variant-input-wrap")
      .forEach((field) => {
        const checked = field.querySelector(
          'input[type="radio"]:checked'
        );
        if (checked && checked.value) {
          selected.push(checked.value.trim());
        }
      });
    document
      .querySelectorAll(
        '.variant-input-wrap select[data-variant-input]'
      )
      .forEach((select) => {
        if (select.value) {
          selected.push(select.value.trim());
        }
      });
    return selected.join(" / ");
  }
  const GLOBO_SKIP_KEYS = [
    "_gpo_options",
    "_gpo_addon_products",
    "_has_gpo",
    "_gpo_product_group",
    "design-notes",
    "design notes",
    "custom color",
    "custom-color",
    "custom color / design notes",
    "artwork",
    "artwork/logo upload",
    "artwork-logo-upload"
  ];
  function getGloboOptions() {
    const selections = [];
    document
      .querySelectorAll('input[name^="properties["]')
      .forEach((input) => {
        const match = input.name.match(
          /^properties\[(.+)\]$/
        );
        if (!match) return;
        const key = match[1].trim();
        const keyLower = key.toLowerCase();
        if (
          GLOBO_SKIP_KEYS.some((skip) =>
            keyLower.includes(skip)
          )
        ) {
          return;
        }
        const value = (input.value || "").trim();
        if (
          !value ||
          value === "{}" ||
          value === "[]"
        ) {
          return;
        }
        selections.push(value);
      });
    return selections;
  }
  function cleanDefaultTitle() {
    const el = document.querySelector(
      ".sticky-atc-variant"
    );
    if (!el) return;
    if (el.innerText.trim() === "Default Title") {
      el.innerText = "";
    }
  }
  let cleanTimeout;
  function cleanINR() {
    clearTimeout(cleanTimeout);
    cleanTimeout = setTimeout(() => {
      document
        .querySelectorAll(".product__price")
        .forEach((el) => {
          el.textContent = el.textContent
            .replace(/INR|USD|CAD|EUR|GBP/gi, "")
            .trim();
        });
    }, 400);
  }
  const stickyBtn =
    document.querySelector(".sticky-atc-btn");
  function syncAvailabilityFromMainButton() {
    const mainBtn = document.querySelector(
      "#MainATC, [data-add-to-cart], .product-form__cart-submit"
    );
    if (!mainBtn || !stickyBtn) return;
    stickyBtn.innerText = mainBtn.innerText.trim();
    stickyBtn.disabled = mainBtn.disabled;
    stickyBtn.classList.toggle(
      "disabled",
      mainBtn.disabled
    );
  }
  function updateUI() {
    const titleEl =
      bar.querySelector(".sticky-atc-title");
    const variantEl =
      bar.querySelector(".sticky-atc-variant");
    const priceEl =
      bar.querySelector(".sticky-atc-price");
    if (titleEl) {
      titleEl.innerText = productData.title;
    }
    if (variantEl) {
      let text = getSelectedVariantFromDOM();
      text = text.replace(
        /^Default Title\s*\/\s*/i,
        ""
      );
      text = text.replace(
        /^Default Title$/i,
        ""
      );
      text = text
        .replace(/^\s*\/\s*/, "")
        .trim();
      const globoOptions = getGloboOptions();
      globoOptions.forEach((val) => {
        if (val) {
          text += (text ? " / " : "") + val;
        }
      });
      variantEl.innerText = text;
    }
    if (priceEl) {
      const priceHTML = getMainPriceHTML();
      if (priceHTML) {
        priceEl.innerHTML = priceHTML;
      }
    }
    cleanDefaultTitle();
    syncAvailabilityFromMainButton();
  }
  document.addEventListener(
    "variant:change",
    function (event) {
      const variant = event.detail?.variant;
      if (!variant) return;
      productData.price = formatMoney(
        variant.price
      );
      productData.variant =
        getSelectedVariantFromDOM();
      cleanINR();
      updateUI();
    }
  );
  document.addEventListener("change", function (e) {
    if (
      e.target.matches(
        'select[data-variant-input]'
      ) ||
      e.target.matches(
        'input[type="radio"]'
      )
    ) {
      setTimeout(updateUI, 50);
    }
    if (
      e.target.closest(
        ".globo-option-container, .spo-container, .gpo-app"
      )
    ) {
      setTimeout(updateUI, 50);
    }
  });
  const priceEl = document.querySelector(
    "[data-product-price]"
  );
  if (priceEl) {
    const priceObserver =
      new MutationObserver(() => {
        productData.price = priceEl.innerText;
        cleanINR();
        updateUI();
      });
    priceObserver.observe(priceEl, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
  const globoContainer = document.querySelector(
    '.globo-option-container, .spo-container, .gpo-app, form[action="/cart/add"]'
  );
  if (globoContainer) {
    const globoObserver =
      new MutationObserver(() => {
        setTimeout(updateUI, 50);
      });
    globoObserver.observe(globoContainer, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "value"],
      childList: true
    });
  }
  window.addEventListener(
    "scroll",
    toggleBar,
    { passive: true }
  );
  window.addEventListener(
    "resize",
    toggleBar
  );
  // bar
  //   .querySelector(".sticky-atc-btn")
  //   ?.addEventListener("click", () => {
  //     const form = document.querySelector(
  //       'form[action*="/cart/add"]'
  //     );
  //     if (!form) return;
  //     if (
  //       typeof form.requestSubmit ===
  //       "function"
  //     ) {
  //       form.requestSubmit();
  //     } else {
  //       form.dispatchEvent(
  //         new Event("submit", {
  //           bubbles: true,
  //           cancelable: true
  //         })
  //       );
  //     }
  //   });

  bar.querySelector(".sticky-atc-btn")?.addEventListener("click", () => {
  const form = document.querySelector('form[action="/cart/add"]');
  if (!form) return;
    const submitBtn = form.querySelector('[type="submit"], button[type="submit"]');
    if (!submitBtn) return;
    submitBtn.click();
  });

  document.addEventListener(
    "DOMContentLoaded",
    () => {
      updateUI();
      toggleBar();
      cleanINR();
      setTimeout(() => {
        updateUI();
      }, 300);
      setTimeout(() => {
        updateUI();
      }, 1000);
    }
  );
  updateUI();
  setTimeout(() => {
    updateUI();
  }, 500);
  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(function(){
      showBar();
      },1000)
      setTimeout(function(){
      toggleBar();
      },1500)
  });
})();
/* END sticky add to cart JS */




$(document).ready(function(){
    $('.custom_output').css('display', 'none');
    $("#modal-overlay").fadeIn();
    $('.loading_data').css('display', 'block');
    $('#modal-overlay').on('click', function(event) {
        $("#modal-overlay").fadeIn();
        event.stopPropagation();
    });
    $.ajax({
        url : 'https://mvpvisualsapi.matrixm.io/quote-orders/order-list.php',
        type : 'GET',
        action : 'get_orders',
        success : function(response) {
          $("#modal-overlay").fadeOut();
          $('.loading_data').css('display', 'none');
          var json = $.parseJSON(response);
          if(json.status == 'success'){
            $('.display_order_data').append(json.output);
            $('.pagination-order').append(json.pagination);
            
          }else{
            jQuery('.success_msg').text('There are some error into form');
          }
        }
    });  
});

$(document).on('click', '.view_order_details', function(e) {
  var data_order_id = $(this).attr('data-order-id');
  var data_order_action = $(this).attr('data-order-action');
  if(data_order_id != '') {
    $.ajax({
      type: "POST",
      url: "https://mvpvisualsapi.matrixm.io/quote-orders/view-details.php",
      data: {
        order_id: data_order_id,
        action: data_order_action
      },
      dataType: "json",
      success: function(response) {
        if(response['status'] == 'success'){
          $('.order-status-btn').html(response['btn_output']);
          $('.order_details_data').html(response['output']);
        }
      }
    });
  }
});

$(document).on('click', '.update_status', function(e) {
  var data_order_id = $(this).attr('data-order-id');
  var data_order_action = $(this).attr('data-order-action');
  var order_status = $(this).attr('data-order-status');
  var btn_ele = $(this);
  $('.order_loader').css('display', 'block');
  if(data_order_id != '') {
    $.ajax({
      type: "POST",
      url: "https://mvpvisualsapi.matrixm.io/quote-orders/update_order.php",
      data: {
        order_id: data_order_id,
        order_status: order_status, 
        action: data_order_action
      },
      dataType: "json",
      success: function(response) {
        if(response['status'] == 'success'){
          btn_ele.text(response['order_status']);
          btn_ele.prop('disabled', 'disabled');
          btn_ele.removeClass('update_status');
          // $('.order_loader').css('display', 'none');
          $('.order_success_msg').text(response['output']);
        }
      }
    });
  }
});  

$(document).on('click', '.update-notes', function(e) {
  var data_order_id = $('.order_id').val();
  var data_order_action = $('.order_action').val();
  var data_order_note = $('.order_note').val();
  
  if(data_order_id != '') {
    $.ajax({
      type: "POST",
      url: "https://mvpvisualsapi.matrixm.io/quote-orders/update_order.php",
      data: {
        order_id: data_order_id,
        action: data_order_action,
        notes: data_order_note
      },
      dataType: "json",
      success: function(response) {
        if(response['status'] == 'success'){
          $('.order_success_msg').text(response['output']);
        }
      }
    });
  }
});  
  
$(document).on('click', '.pagination_link', function(e) {
  $("#modal-overlay").fadeIn();
  $('.loading_data').css('display', 'block');
  var data_info = $(this).attr('data-info');
  var data_rel = $(this).attr('data-rel');
  var data_store = $(this).attr('data-store');
  if(data_info != '') {
    $.ajax({
      type: "GET",
      url: "https://mvpvisualsapi.matrixm.io/quote-orders/pagination.php",
      data: {
        page_info: data_info,
        rel: data_rel,
        url: data_store
      },
      dataType: "json",
      success: function(response) {
        if( response['prev'] != '' ) {
          $('button[data-rel="previous"]').attr('data-info', response['prev']);
          $('button[data-rel="previous"]').removeAttr('disabled');
        } else {
          $('button[data-rel="previous"]').attr('data-info', "");
          $('button[data-rel="previous"]').attr('disabled', 'disabled');
        }
        if( response['next'] != '' ) {
          $('button[data-rel="next"]').attr('data-info', response['next']);
          $('button[data-rel="next"]').removeAttr('disabled');
        } else {
          $('button[data-rel="next"]').attr('data-info', "");
          $('button[data-rel="next"]').attr('disabled', 'disabled');
        }
        if( response['html'] != '' ) {
          $("#modal-overlay").fadeOut();
          $('.loading_data').css('display', 'none');
          $('.display_order_data').html(response['html']);
        }
      }
    });
  }
}); 

$(document).ready(function() {
    // Open modal
$(document).on('click', '.open-modal', function(e) {  
    $("#custom-modal").fadeIn();
    $("#modal-overlay").fadeIn();
});

// Close modal
$(document).on('click', '#close-modal', function(e) {
    e.preventDefault();
    $("#custom-modal").fadeOut();
    $("#modal-overlay").fadeOut();
});

// Close modal when clicking outside of it
$(document).mouseup(function(e) {
    var modal = $("#custom-modal");
    var modal_notes = $("#custom-modal-notes");
    if (!modal.is(e.target) && modal.has(e.target).length === 0 && !modal_notes.is(e.target) && modal_notes.has(e.target).length === 0) {
        modal.fadeOut();
        $("#modal-overlay").fadeOut();
        $('.order_loader').css('display','none');
    }
    if (!modal_notes.is(e.target) && modal_notes.has(e.target).length === 0) {
        modal_notes.fadeOut();
    }
});

$(document).on('click', '.open-notes-modal', function(e) {  
    var order_id = $(this).attr('data-order-id');
    $('.order_id').val(order_id);
    $('.update-notes').attr('data-order-id', order_id);
    $("#custom-modal-notes").fadeIn();
    $("#modal-overlay").fadeIn();
});

// Close notes modal
$("#close-modal-notes").click(function(e) {
    e.preventDefault();
    $("#custom-modal-notes").fadeOut();
    $("#modal-overlay").fadeOut();
});
}); 